import { render, staticRenderFns } from "./glassBlockList.vue?vue&type=template&id=7379062a&"
import script from "./glassBlockList.vue?vue&type=script&lang=js&"
export * from "./glassBlockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports